<template>
  <div>
    <a-card class="customer-filter">
      <a-form-model :form="filterForm" :label-col="{ span: 6 }" :model="filterForm" class="search-form">
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-model-item label="名称">
              <a-input v-model="filterForm.name" placeholder="流水线名称" class="form-model-item" @change="handleChange('name')" />
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="与我相关">
              <a-radio-group v-model="filterForm.about" button-style="solid" @change="onSearch">
                <a-radio-button value="all"> 全部 </a-radio-button>
                <a-radio-button value="about"> 与我相关 </a-radio-button>
                <a-radio-button value="aboutTeam"> 团队相关 </a-radio-button>
              </a-radio-group>
            </a-form-model-item>
          </a-col>
          <a-col :span="6" style="float: right; text-align: right">
            <a-button v-tc="{ name: '查询' }" type="primary" @click="getPipelineList">查询</a-button>
            <a-button v-tc="{ name: '重置' }" :style="{ margin: '0 8px' }" @click="onReset">重置</a-button>
          </a-col>
        </a-row>
      </a-form-model>
    </a-card>
    <a-card title="流水线列表" class="filter-data" size="small">
      <span slot="extra">
        <a-button v-has="{ code: 'project:cicd:pipeline:add', project: projectId }" v-tc="{ name: '创建流水线' }" class="handle-menu" type="primary" icon="plus" @click="onAdd">创建流水线</a-button>
      </span>
      <a-table :pagination="pagination" :columns="columns" size="middle" :data-source="tableData" row-key="pipeline_id" :loading="loading" @change="handlePageChange">
        <span slot="action" slot-scope="text, record">
          <a-tooltip placement="top">
            <template slot="title">
              <span>立即构建</span>
            </template>
            <a v-dis="{ code: 'project:cicd:pipeline:run', project: projectId }" v-tc="{ name: '立即构建' }" class="action-button" @click="onBuild(record)"><a-icon type="play-circle" /></a>
          </a-tooltip>
          <a-tooltip placement="top">
            <template slot="title">
              <span>编辑流水线</span>
            </template>
            <a v-dis="{ code: 'project:cicd:pipeline:edit', project: projectId }" v-tc="{ name: '编辑流水线' }" class="action-button" @click="onEdit(record)"><a-icon type="edit" /></a>
          </a-tooltip>

          <a-tooltip placement="top">
            <template slot="title">
              <span>构建历史</span>
            </template>
            <a v-dis="{ code: 'project:cicd:pipeline:record', project: projectId }" v-tc="{ name: '构建历史' }" class="action-button" @click="onRecord(record)"><a-icon type="clock-circle" /></a>
          </a-tooltip>
          <a-tooltip placement="top">
            <template slot="title">
              <span>删除流水线</span>
            </template>
            <a v-dis="{ code: 'project:cicd:pipeline:delete', project: projectId }" v-tc="{ name: '删除流水线' }" class="action-button" @click="onDelete(record)"><a-icon type="delete" /></a>
          </a-tooltip>
        </span>
        <span slot="status" slot-scope="text, record">
          <span v-if="record.latest_record && record.latest_record.status">
            <a-tag :color="pipelineBuildStatus[record.latest_record.status].color"> {{ pipelineBuildStatus[record.latest_record.status].label }} </a-tag>
          </span>
          <span v-else> -- </span>
        </span>
        <span slot="image" slot-scope="text, record">
          <span v-if="record.latest_record && record.latest_record.status === 3">
            {{ record.latest_record.params.image_name }}
          </span>
          <span v-else> -- </span>
        </span>
        <span slot="branch" slot-scope="text, record">
          <span v-if="record.latest_record && record.latest_record">
            {{ record.latest_record.params.git_branch }}
          </span>
          <span v-else> -- </span>
        </span>
        <span slot="created_time" slot-scope="text, record">
          <span v-if="record.latest_record && record.latest_record.created_time">{{ record.latest_record.created_time }}</span>
          <span v-else> -- </span>
        </span>
        <span slot="duration" slot-scope="text, record">
          <span v-if="record.latest_record && record.latest_record.duration">{{ record.latest_record.duration }}</span>
          <span v-else> -- </span>
        </span>
        <span slot="creator" slot-scope="text, record">
          <user-profiles v-if="record.latest_record" :value="[record.latest_record.creator.id]" avatar />
          <span v-else> -- </span>
        </span>
      </a-table>
    </a-card>
    <pipeline-drawer :visible="visible" :pipeline-id="pipelineId" @close="close" />
    <pipeline-build ref="pipelineBuildRef" @close="close" />
    <pipeline-record ref="pipelineRecordRef" />
  </div>
</template>

<script>
import { debounce } from 'lodash';
import { pipelineBuildStatus } from '@/utils/dictionary';
import { pipelineList, pipelineDelete } from '@/api/project/pipeline';

import PipelineBuild from '@/pages/project/components/PipelineBuild';
import PipelineDrawer from '@/pages/project/components/PipelineDrawer';
import PipelineRecord from '@/pages/project/components/PipelineRecord';

const columns = [
  {
    title: 'ID',
    dataIndex: 'pipeline_id',
    key: 'pipeline_id',
    align: 'center',
    width: 80
  },
  {
    title: '名称',
    dataIndex: 'name',
    ellipsis: true,
    key: 'name',
    width: 240
  },
  {
    width: 100,
    title: '默认分支',
    ellipsis: true,
    dataIndex: 'default_branch',
    key: 'default_branch'
  },
  {
    width: 100,
    title: '最近构建状态',
    scopedSlots: { customRender: 'status' }
  },
  {
    width: 100,
    ellipsis: true,
    title: '最近构建镜像',
    scopedSlots: { customRender: 'image' }
  },
  {
    width: 100,
    ellipsis: true,
    title: '最近构建人',
    scopedSlots: { customRender: 'creator' }
  },
  {
    width: 100,
    ellipsis: true,
    title: '最近构建分支',
    scopedSlots: { customRender: 'branch' }
  },
  {
    width: 100,
    title: '持续时间',
    ellipsis: true,
    scopedSlots: { customRender: 'duration' }
  },
  {
    width: 165,
    title: '最近构建时间',
    scopedSlots: { customRender: 'created_time' }
  },
  {
    title: '操作',
    width: 140,
    scopedSlots: { customRender: 'action' }
  }
];

export default {
  components: { PipelineDrawer, PipelineBuild, PipelineRecord },
  data() {
    return {
      pipelineBuildStatus,
      projectId: parseInt(this.$route.params.project_id) || null,
      filterForm: {
        name: this.$route.query.name || null,
        result: null,
        about: window.localStorage.getItem('about_release') || 'all',
        project_id: parseInt(this.$route.params.project_id) || null,
        page_size: parseInt(this.$route.query.page_size) || null,
        page_number: parseInt(this.$route.query.page_number) || null
      },
      paramForm: {
        time_field: 'created_time',
        fields: []
      },
      loading: false,
      pagination: {
        size: 'large',
        total: 0,
        current: parseInt(this.$route.query.page_number) || 1,
        pageSize: parseInt(this.$route.query.page_size) || 20, // 每页中显示20条数据
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'], // 每页中显示的数据
        showTotal: total => `共 ${total} 条` // 分页中显示总的数据
      },
      visible: false,
      pipelineId: null,
      expand: false,
      tableData: [],
      columns
    };
  },
  computed: {
    count() {
      return this.expand ? 11 : 7;
    }
  },
  mounted() {
    this.getPipelineList();
  },
  methods: {
    handleChange: debounce(function (item = null) {
      const customerQuery = { ...this.$route.query };
      if (item.includes(['name']) && this.filterForm[item] === '') {
        this.$set(this.filterForm, item, null);
        delete customerQuery[item];
      } else {
        this.$set(customerQuery, item, this.filterForm[item]);
      }
      this.pagination.current = 1;
      this.filterForm.page_number = 1;
      this.$router.push({ query: customerQuery });
      this.getPipelineList();
    }, 1000),
    onSearch() {
      this.filterForm.page_number = 1;
      localStorage.setItem('about_release', this.filterForm.about);
      this.getPipelineList();
    },

    // 点击添加
    onAdd() {
      this.pipelineId = null;
      this.visible = true;
    },

    // 点击编辑
    onEdit(record) {
      this.pipelineId = record.pipeline_id;
      this.visible = true;
    },

    // 点击构建
    onBuild(record) {
      this.$nextTick(() => {
        this.$refs.pipelineBuildRef.onOpen({
          git_id: record.params.git_id,
          pipeline_id: record.pipeline_id,
          branch: (record.latest_record && record.latest_record.params && record.latest_record.params.git_branch) || record.default_branch
        });
      });
    },

    // 点击查看构建记录
    onRecord(record) {
      this.$nextTick(() => {
        this.$refs.pipelineRecordRef.onOpen({ pipeline_id: record.pipeline_id });
      });
    },

    // 点击重置
    onReset() {
      this.filterForm = {
        name: null,
        pipeline_type: null,
        project_id: parseInt(this.$route.params.project_id) || null,
        page_size: 20,
        page_number: 1
      };
      this.pagination.current = 1;
      this.pagination.pageSize = 20;
      this.$router.push({
        query: {}
      });
      this.getPipelineList();
    },

    toggle() {
      this.expand = !this.expand;
    },

    // 获取流水线列表
    getPipelineList() {
      this.loading = true;
      pipelineList({ ...this.filterForm, page_size: this.pagination.pageSize, page_number: this.pagination.current })
        .then(response => {
          this.tableData = response.data.items;
          this.pagination.total = response.data.total;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    // 删除流水线
    onDelete(record) {
      const self = this;
      const projectId = this.projectId;
      this.$confirm({
        title: '确认',
        content: '确认要删除该流水线吗',
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk() {
          pipelineDelete({ pipeline_id: record.pipeline_id, project_id: projectId }).then(() => {
            self.$message.success('删除成功');
            self.getPipelineList();
          });
        }
      });
    },

    handlePageChange(pagination) {
      this.pagination = pagination;
      const customerQuery = { ...this.$route.query };
      this.filterForm.page_size = pagination.pageSize;
      this.filterForm.page_number = pagination.current;
      this.$set(customerQuery, 'page_size', pagination.pageSize);
      this.$set(customerQuery, 'page_number', pagination.current);
      this.getPipelineList();
      this.$router.push({ query: customerQuery });
    },

    // 关闭弹窗
    close() {
      this.visible = false;
      this.recordVisible = false;
      this.pipelineId = null;
      this.getPipelineList();
    }
  }
};
</script>

<style lang="less">
.customer-filter {
  margin-bottom: 16px;
}

.handle-menu {
  margin: 0 5px;
}
.search-form .ant-form-item {
  display: flex;
}

.search-form .ant-form-item-control-wrapper {
  flex: 1;
}
</style>
<style lang="less" scoped>
.ant-form-item {
  margin-bottom: 0;
}
.action-button {
  font-size: 18px;
  margin: 2px 6px;
  // color: #8b8b8b;
}
.action-button:hover {
  color: #1b9aee;
}
</style>
